export const mockCustomers = [
  {
    id: '1',
    name: 'Fatma Kaya',
    phone: '0533 456 78 90',
    total_purchases: 3200,
    total_paid: 1200,
    remaining_debt: 2000,
    last_payment_date: '2026-06-01',
    status: 'Kısmi Ödendi',
    notes: 'Gelecek hafta kalanı ödenecek',
    created_at: '2026-06-01T11:30:00Z',
  },
  {
    id: '2',
    name: 'Merve Şahin',
    phone: '0536 234 56 78',
    total_purchases: 2500,
    total_paid: 500,
    remaining_debt: 2000,
    last_payment_date: '2026-05-28',
    status: 'Kısmi Ödendi',
    notes: '2 taksit kaldı',
    created_at: '2026-05-28T09:00:00Z',
  },
  {
    id: '3',
    name: 'Selin Çelik',
    phone: '0537 567 89 01',
    total_purchases: 5800,
    total_paid: 0,
    remaining_debt: 5800,
    last_payment_date: '2026-05-25',
    status: 'Bekliyor',
    notes: 'Vade tarihi 10 Haziran',
    created_at: '2026-05-25T16:00:00Z',
  },
  {
    id: '4',
    name: 'Gizem Özdemir',
    phone: '0539 123 45 67',
    total_purchases: 7500,
    total_paid: 2500,
    remaining_debt: 5000,
    last_payment_date: '2026-05-18',
    status: 'Kısmi Ödendi',
    notes: '3 taksit kaldı',
    created_at: '2026-05-18T13:00:00Z',
  },
  {
    id: '5',
    name: 'Ece Yıldız',
    phone: '0541 789 01 23',
    total_purchases: 1200,
    total_paid: 0,
    remaining_debt: 1200,
    last_payment_date: '2026-05-12',
    status: 'Gecikti',
    notes: 'Vade 1 Hazirandı, hâlâ ödenmedi',
    created_at: '2026-05-12T15:00:00Z',
  },
  {
    id: '6',
    name: 'Ayşe Yılmaz',
    phone: '0532 123 45 67',
    total_purchases: 4500,
    total_paid: 4500,
    remaining_debt: 0,
    last_payment_date: '2026-06-01',
    status: 'Kapandı',
    notes: '',
    created_at: '2026-06-01T10:00:00Z',
  },
  {
    id: '7',
    name: 'Zeynep Demir',
    phone: '0535 789 01 23',
    total_purchases: 1800,
    total_paid: 1800,
    remaining_debt: 0,
    last_payment_date: '2026-05-30',
    status: 'Kapandı',
    notes: '',
    created_at: '2026-05-30T14:00:00Z',
  },
  {
    id: '8',
    name: 'Burcu Aydın',
    phone: '0538 890 12 34',
    total_purchases: 2200,
    total_paid: 2200,
    remaining_debt: 0,
    last_payment_date: '2026-05-20',
    status: 'Kapandı',
    notes: '',
    created_at: '2026-05-20T11:00:00Z',
  },
  {
    id: '9',
    name: 'Aslı Karaca',
    phone: '0540 456 78 90',
    total_purchases: 1900,
    total_paid: 1900,
    remaining_debt: 0,
    last_payment_date: '2026-05-15',
    status: 'Kapandı',
    notes: '',
    created_at: '2026-05-15T10:00:00Z',
  },
  {
    id: '10',
    name: 'Nazlı Koç',
    phone: '0542 234 56 78',
    total_purchases: 2800,
    total_paid: 2800,
    remaining_debt: 0,
    last_payment_date: '2026-05-10',
    status: 'Kapandı',
    notes: '',
    created_at: '2026-05-10T09:00:00Z',
  },
];